// NOTE: This Obj should be merged with PageProductSeries when we switch off Scrivito Ruby app
import React, { useState, useEffect } from "react";
import * as Scrivito from "scrivito";
import { getCategoryClient, getCategoryLanguage } from "utils";
import { Spinner, ObjValidator } from "components";
import { useTranslate } from "hooks";

const ProductSeries = Scrivito.connect(({ page }) => {
  const translate = useTranslate();
  const [noFoundErr, setNoFoundErr] = useState();
  useEffect(() => {
    Scrivito.load(() =>
      Scrivito.Obj.where("_objClass", "equals", "PageProductSeries")
        .and("categorySeries", "equals", page.get("categorySeries"))
        .and("categoryClients", "equals", getCategoryClient())
        .and("categoryLanguages", "equals", getCategoryLanguage())
        .first(),
    ).then((pageObj) => {
      if (pageObj) {
        window.location.replace(Scrivito.urlFor(pageObj)); // redirects from ProductSeries to PageProductSeries
      } else {
        setNoFoundErr(true);
      }
    });
  }, [page]);
  return noFoundErr ? (
    <div>{translate("ERROR_PAGE_NOT_FOUND_TITLE")}</div>
  ) : (
    <div className="text-center">
      <Spinner />
    </div>
  );
});
const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <ProductSeries {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ProductSeries", CheckedPage);
